import React, { useEffect, useState } from 'react';
import useAuthStore from './stores/useAuthStore';
 
const AuthProvider = ({ children }) => {
  const { initAuth } = useAuthStore();
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    const initialize = async () => {
      await initAuth();
      setIsInitialized(true);
    };

    initialize();
  }, [initAuth]);

  if (!isInitialized) {
    // You could show a loading spinner here
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }

  return children;
};

export default AuthProvider;